import React, { Suspense, lazy } from "react";

/*
  Mantine leverer ett samlet styles.css på 223 kB, der Lighthouse målte 176 kB
  som ubrukt. Vi importerer i stedet CSS-en per komponent. Listen må holdes i
  synk med komponentene vi faktisk bruker — legger du til en ny Mantine-
  komponent, må stilarket dens legges til her.
  global.css er fundamentet (reset + globale stiler); CSS-variablene injiserer
  MantineProvider selv ved kjøring.
*/
import "@mantine/core/styles/global.css";
import "@mantine/core/styles/UnstyledButton.css";
import "@mantine/core/styles/VisuallyHidden.css";
import "@mantine/core/styles/Loader.css";
import "@mantine/core/styles/Paper.css";
import "@mantine/core/styles/Accordion.css";
import "@mantine/core/styles/ActionIcon.css";
import "@mantine/core/styles/Anchor.css";
import "@mantine/core/styles/Burger.css";
import "@mantine/core/styles/Button.css";
import "@mantine/core/styles/Card.css";
import "@mantine/core/styles/CloseButton.css";
import "@mantine/core/styles/Container.css";
import "@mantine/core/styles/Grid.css";
import "@mantine/core/styles/Group.css";
import "@mantine/core/styles/Image.css";
import "@mantine/core/styles/Input.css";
import "@mantine/core/styles/List.css";
import "@mantine/core/styles/Notification.css";
import "@mantine/core/styles/SimpleGrid.css";
import "@mantine/core/styles/Text.css";
import "@mantine/core/styles/ThemeIcon.css";
import "@mantine/core/styles/Timeline.css";
import "@mantine/core/styles/Title.css";

import { MantineProvider } from "@mantine/core";
import '@mantine/notifications/styles.css';
import { Notifications } from '@mantine/notifications';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Element } from "react-scroll";
import "./components/styles.scss";

import { HeaderComponent } from "./components/Header";
import { HeroComponent } from "./components/Hero";
import { FeaturesTitle } from "./components/Focus";
import { ProcessComponent } from "./components/Process";
import { FeaturesComponent } from "./components/Features";
import { HolisticIntro } from "./components/HolisticIntro";
import { ContactComponent } from "./components/Contact";
import { FooterComponent } from "./components/Footer";
import { FaqComponent } from "./components/FAQ";

// Lastes lazy: Plan er egen rute, og About drar inn karusell-biblioteket (embla)
const Plan = lazy(() => import("./components/Plan"));
const Personvern = lazy(() => import("./components/Personvern"));
const AboutMe = lazy(() =>
  import("./components/About").then((m) => ({ default: m.AboutMe }))
);

function Home() {
  return (
    <div>
      <HeaderComponent />
      <HeroComponent />
      <HolisticIntro />
      <FeaturesTitle />
      <Element name="about">
        <Suspense fallback={null}>
          <AboutMe />
        </Suspense>
      </Element>
      <Element name="features">
        <FeaturesComponent />
      </Element>
      <Element name="process">
        <ProcessComponent />
      </Element>
      <Element name="faq">
        <FaqComponent />
      </Element>
      <Element name="contact">
        <ContactComponent />
      </Element>
      <FooterComponent />
    </div>
  );
}

function App() {
  return (
    <MantineProvider
      defaultColorScheme="dark"
      theme={{
        fontFamily: "Inter, sans-serif",
        headings: { fontFamily: "Inter, sans-serif" },
        primaryColor: "teal",
      }}
    >
      <Router>
        <Notifications />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/priser" element={<Plan />} />
            <Route path="/personvern" element={<Personvern />} />
            <Route path="/informasjon" element={<Navigate to="/home" />} />
          </Routes>
        </Suspense>
      </Router>
    </MantineProvider>
  );
}

export default App;
